import { Buffer } from 'buffer/';
// Only polyfill Buffer if not already present and all required properties exist
if (typeof window !== 'undefined' && (!window.Buffer || typeof window.Buffer.from !== 'function')) {
  // Assign Buffer polyfill for browser, and add missing properties for compatibility
  // @ts-ignore
  window.Buffer = Object.assign(Buffer, {
    copyBytesFrom: () => { throw new Error('Not implemented'); },
    poolSize: 8192,
  });
}
